import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Buddies, BUDDIES_FIT_FILL, BUDDIES_PAIR, SpeechBubble, SPEECH_BUBBLE_SIZE_SMALL, SPEECH_BUBBLE_TAIL_BOTTOM_START } from '@aibuild/ui';
import { COACH_BUDDIES_PX, COACH_SHOWN_MS } from './builderWorkspace.constants';
import { Arrow, Bubble, CoachRoot, CoachRow } from './BuilderAgentCoach.styled';

interface BuilderAgentCoachProps {
  /** Hung under the chat toggle; otherwise in the corner, under the phone's pane tabs. */
  readonly anchored: boolean;
  readonly onDismiss: () => void;
}

const BuilderAgentCoach: React.FC<BuilderAgentCoachProps> = ({ anchored, onDismiss }) => {
  const intl = useIntl();

  useEffect(() => {
    const id = window.setTimeout(onDismiss, COACH_SHOWN_MS);
    return () => window.clearTimeout(id);
  }, [onDismiss]);

  return (
    <CoachRoot $anchored={anchored} role="status" data-testid="app-builder__coach">
      <Arrow viewBox="0 0 56 44" aria-hidden="true">
        <path d="M10 42 C 12 22, 26 8, 44 3" />
        <path d="M35 3.5 L44 3 L41 11.5" />
      </Arrow>
      <CoachRow>
        <Buddies who={BUDDIES_PAIR} act="point" size={COACH_BUDDIES_PX} fit={BUDDIES_FIT_FILL} />
        <Bubble>
          <SpeechBubble
            size={SPEECH_BUBBLE_SIZE_SMALL}
            tail={SPEECH_BUBBLE_TAIL_BOTTOM_START}
            onClose={onDismiss}
            closeLabel={intl.formatMessage({ id: 'apps.builder.coach.close', defaultMessage: 'Got it' })}
            dataTestId="app-builder__coach-bubble"
          >
            {intl.formatMessage({
              id: 'apps.builder.coach',
              defaultMessage: 'Chat with us in Builder agent to change and improve your app.',
            })}
          </SpeechBubble>
        </Bubble>
      </CoachRow>
    </CoachRoot>
  );
};

export default BuilderAgentCoach;
